const style = () => ({
  container: {
    display: 'flex',
    backgroundPosition: 'center',
    backgroundSize: 'cover'
  },
  imageContainer: {
    background: '#DDE3EB',
    width: '50%'
  },
  positionLeft: {
    flexDirection: 'row'
  },
  positionRight: {
    flexDirection: 'row-reverse'
  },
  positionCenter: {
    '& $imageContainer': {
      width: '100%'
    },
    '& $descContainer': {
      display: 'none'
    }
  },
  descContainer: {
    width: '50%',
    display: 'flex',
    position: 'relative'
  },
  descHolder: ({ size, printMode }) => ({
    padding: size(5.5),
    maxHeight: '100%',
    overflow: printMode ? 'hidden' : 'auto',
    width: '100%'
  }),
  icon: {
    margin: '2px 5px 0 0',
    height: '10px',
    width: '12px'
  },
  title: ({ size }) => ({
    margin: `0 0 ${size(3.2, { scaleFactor: 'sm' })}`,
    fontWeight: 'bold'
  }),
  imageBox: ({ size }) => ({
    padding: size(4)
  }),
  centerDesc: {
    justifyContent: 'center'
  },
  clickable: {
    cursor: 'pointer'
  }
})

export default style
